import UserProfile from "@app/components/UserProfile/UserProfile";

export default function ProfileRoute() {
  return <UserProfile />;
}
